// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__2XJfl","details":"Details_details__2AyyQ","content":"Details_content__3Yq-c"};